import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-enetassess',
  templateUrl: './enetassess.component.html',
  styleUrls: ['./enetassess.component.scss']
})
export class EnetassessComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";
    var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0) {
      
      generalSvc.logoutUser(enetsecure);
    }

    if (dataSvc.currentUser.Exams.filter(x => x.Completed != true).length == 0)
      generalSvc.logoutUser(enetsecure);

      if(dataSvc != null && dataSvc !== undefined){
        var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
        if(usersLanguage != null){
          translate.setDefaultLang(usersLanguage);
          translate.use(usersLanguage);
        }
        else{
          translate.setDefaultLang('en');
          translate.use('en');
        }
      }
      else{
        translate.setDefaultLang('en');
        translate.use('en');
      }      
  }

  ngOnInit() {
  }

  launchExam(examIndex) {
    this.dataSvc.currentExamIndex = examIndex;
    this.dataSvc.pulseTimeLog("Start");
    this.generalSvc.launchExam();
  }

  logout(){
    var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    this.generalSvc.logoutUser(enetsecure);
  }
}